// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/*\r\n * @Descripttion: 基本样式变量配置\r\n * @Date: 2022-03-30 10:55:04\r\n * @LastEditTime: 2022-04-07 14:08:09\r\n */\n", ""]);
// Exports
module.exports = exports;
